module.exports = __webpack_public_path__ + "static/media/hg1.3f97a7bc.jpeg";